import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStateService } from '../services/app-state.service';

// Route data: { roles: ['admin'] } — restricts a route to the listed roles.
export const roleGuard: CanActivateFn = (route) => {
  const appState = inject(AppStateService);
  const router = inject(Router);
  const allowedRoles: string[] = route.data?.['roles'] ?? [];
  const profile = appState.profile() ?? appState.restoreProfile();

  if (!profile) return router.parseUrl('/login');
  if (allowedRoles.length === 0 || allowedRoles.includes(profile.role)) return true;
  return router.parseUrl('/dashboard');
};
